import { useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import { Select } from "components/base/Form";
import Page from "components/base/Page";
import SearchBar from "components/base/SearchBar";
import Spinner from "components/base/Spinner";
import useSearch from "hooks/useSearch";
import { FETCH_MARKETTIME_ORDERS } from "./markettime/graphql";
import OrdersView from "./markettime/OrdersView";

const OrdersPage = () => {
  const [q, setQ] = useSearch();
  const { loading, error, data } = useQuery(FETCH_MARKETTIME_ORDERS);

  let finalError = error;
  if (data) {
    const res = JSON.parse(data.mtOrders);
    if (res.error) finalError = res.error;
    console.log("res", res);
  }

  return (
    <Page title="Waboba INC Orders" className="h-screen">
      <div className="p-6 flex flex-col h-full overflow-auto">
        <div className="flex items-center space-x-3">
          <Select>
            <option value="markettime">Markettime</option>
          </Select>
          <div className="flex-1">
            <SearchBar
              placeholder="Search Orders by number, customer name, etc.."
              initialQuery={q}
              onChange={setQ}
            />
          </div>
        </div>

        <div className="mt-4 relative card p-0 flex-1 overflow-auto">
          {loading && <Spinner />}
          {finalError && <Errors error={finalError} />}
          {!loading && !finalError && data && <OrdersView data={data} q={q} />}
        </div>
      </div>
    </Page>
  );
};

export default OrdersPage;
